import React, { useCallback } from "react";
import AsyncSelect from "react-select/async";

const GooglePlaceSelect = ({ value, onChange }) => {

  // Extract City, State from Google Address Components
  const parseAddressComponents = (components) => {
    let city = "";
    let state = "";

    components.forEach((comp) => {
      if (comp.types.includes("locality")) {
        city = comp.long_name;
      }
      if (comp.types.includes("administrative_area_level_1")) {
        state = comp.long_name;
      }
    });

    return { city, state };
  };

  // 1️⃣ Get Current Location → Fetch Full Geocoded Details
  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK" && results[0]) {
            const { city, state } = parseAddressComponents(
              results[0].address_components
            );
console.log(results[0].formatted_address,
          lat,
          lng,
          city,
          state,)
            onChange({
              label: results[0].formatted_address,
              value: "current-location",
              lat,
              lng,
              city,
              state,
            });
          }
        });
      },
      () => alert("Unable to retrieve location")
    );
  };

  // 2️⃣ Load Google Place Autocomplete Options
  const loadOptions = useCallback((inputValue, callback) => {
    if (!window.google) return callback([]);

    const service = new window.google.maps.places.AutocompleteService();

    if (!inputValue) {
      callback([
        {
          label: "📍 Use My Current Location",
          value: "__current_location__",
          isCurrentLocation: true,
        },
      ]);
      return;
    }

    service.getPlacePredictions({ input: inputValue }, (predictions) => {
      let results =
        predictions?.map((p) => ({
          label: p.description,
          value: p.place_id,
        })) || [];

      results.unshift({
        label: "📍 Use My Current Location",
        value: "__current_location__",
        isCurrentLocation: true,
      });

      callback(results);
    });
  }, []);

  // 3️⃣ Handle place selection → Fetch Full Place Details
  const handleSelect = (option) => {
    if (!option) {
  console.log("Option error is null!");
  return;
}

    if (option?.isCurrentLocation) {
      getCurrentLocation();
      return;
    }

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ placeId: option.value }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();

        const { city, state } = parseAddressComponents(
          results[0].address_components
        );
console.log( results[0].formatted_address,
          lat,
          lng,
          city,
          state,)
        onChange({
          ...option,
          lat,
          lng,
          city,
          state,
        });
      }
    });
  };

  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadOptions}
      defaultOptions={[
        {
          label: "📍 Use My Current Location",
          value: "__current_location__",
          isCurrentLocation: true,
        },
      ]}
      placeholder="Search location..."
      value={value}
      onChange={handleSelect}
      className="w-100 "
      isClearable
    />
  );
};

export default GooglePlaceSelect;
